<template>
  <div @click="onFieldClick" class="edit-cell">
    <el-tooltip v-if="!editMode && !showInput"
                :placement="toolTipPlacement"
                :open-delay="toolTipDelay"
                :content="toolTipContent">
      <div tabindex="0" @keyup.enter="onFieldClick">
        <slot name="content"></slot>
      </div>

    </el-tooltip>
    <template v-if="isInputNumber">
      <component :is="editableComponent"
                 v-if="editMode || showInput"
                 ref="input"
                 @focus="onFieldClick"
                 @keyup.enter.native="onInputExit"
                 oninput="value=value.replace(/[^\d^\.^\-]/g,'')"
                 v-on="listeners"
                 v-bind="$attrs"
                 v-model="model" size="mini" clearable>
        <slot name="edit-component-slot"></slot>
      </component>
    </template>
    <template v-else>
      <component :is="editableComponent"
                 v-if="editMode || showInput"
                 ref="input"
                 @focus="onFieldClick"
                 @keyup.enter.native="onInputExit"
                 v-on="listeners"
                 v-bind="$attrs"
                 v-model="model" size="mini" class="edit-cell-input" clearable>
        <slot name="edit-component-slot"></slot>
      </component>
    </template>
  </div>
</template>
<script>
export default {
  name: "editable-cell",
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    toolTipContent: {
      type: String,
      default: "点击编辑"
    },
    toolTipDelay: {
      type: Number,
      default: 500
    },
    toolTipPlacement: {
      type: String,
      default: "top-start"
    },
    showInput: {
      type: Boolean,
      default: false
    },
    editableComponent: {
      type: String,
      default: "el-input"
    },
    closeEvent: {
      type: String,
      default: "blur"
    },
    isInputNumber: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editMode: false
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    listeners() {
      return {
        [this.closeEvent]: this.onInputExit,
        ...this.$listeners
      };
    }
  },
  methods: {
    onFieldClick() {
      // console.log('1')
      this.editMode = true;
      this.$nextTick(() => {
        let inputRef = this.$refs.input;
        if (inputRef) {
          inputRef.focus();
          inputRef.select();//选中状态
        }
      });
    },
    onInputExit() {
      // console.log('2')
      this.editMode = false;
    },
    onInputChange(val) {
      // console.log('3')
      this.$emit("input", val);
    }
  }
};
</script>
